var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RcPageLoader',[_c(_vm.layout,{tag:"component"})],1),_c('vue-progress-bar'),_c('RcUploaderModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }